// Keep all your current imports
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaUser, FaHeart, FaShoppingCart, FaBars } from "react-icons/fa";

function NavBar({ user, onLogout }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [menuOpen, setMenuOpen] = useState(false);
  const [accountOpen, setAccountOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSearch = () => {
    if (searchQuery.trim()) {
      navigate(`/products?search=${encodeURIComponent(searchQuery)}`);
    }
  };

  const handleSubCategoryClick = (subcat) => {
    navigate(`/products?subcategory=${encodeURIComponent(subcat)}`);
    setCategoryOpen(false);
  };

  return (
    <>
      <nav style={styles.navbar}>
        {/* Left */}
        <div style={styles.left}>
          <Link to="/" style={styles.logo}>BigStyle</Link>
          <Link to="/" style={styles.link}>Home</Link>
          <div style={styles.dropdown}>
            <span
              style={styles.dropdownToggle}
              onClick={() => setCategoryOpen(!categoryOpen)}
            >
              Categories ▾
            </span>
            {categoryOpen && (
              <div style={styles.categoryMenu}>
                <div style={styles.activeCategory}>
                  Clothing ▸
                  <div style={styles.subMenu}>
                    <div onClick={() => handleSubCategoryClick("men")} style={styles.subItem}>👕 Men</div>
                    <div onClick={() => handleSubCategoryClick("women")} style={styles.subItem}>👗 Women</div>
                    <div onClick={() => handleSubCategoryClick("kids")} style={styles.subItem}>🧒 Kids</div>
                  </div>
                </div>
                <div style={styles.inactiveCategory}>Electronics (coming soon)</div>
                <div style={styles.inactiveCategory}>Furniture (coming soon)</div>
              </div>
            )}
          </div>
          <Link to="/about" style={styles.link}>About Us</Link>
        </div>

        {/* Center */}
        <div style={styles.center}>
          <div style={styles.searchGroup}>
            <input
              type="text"
              placeholder="Search clothing..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSearch()}
              style={styles.searchInput}
            />
            <button onClick={handleSearch} style={styles.searchBtn}>🔍</button>
          </div>
        </div>

        {/* Right */}
        <div style={styles.right}>
          <a
            href="tel:+918107215810"
            style={styles.phoneCTA}
            onMouseOver={(e) => {
              e.target.style.transform = "scale(1.05)";
              e.target.style.boxShadow = "0 0 10px #2ecc71";
            }}
            onMouseOut={(e) => {
              e.target.style.transform = "scale(1)";
              e.target.style.boxShadow = "0 0 0 transparent";
            }}
          >
            <span style={styles.ringingIcon}>📞</span> Call +91 81072 15810
          </a>

          <div style={{ position: "relative" }}>
            <FaUser onClick={() => setAccountOpen(!accountOpen)} style={styles.icon} title="Account" />
            {accountOpen && (
              <div style={styles.dropdownBox}>
                {user ? (
                  <>
                    <div>👋 {user.first_name}</div>
                    <button onClick={onLogout} style={styles.dropdownBtn}>Logout</button>
                  </>
                ) : (
                  <>
                    <Link to="/login" style={styles.dropdownItem}>Login</Link>
                    <Link to="/signup" style={styles.dropdownItem}>Signup</Link>
                  </>
                )}
              </div>
            )}
          </div>

          <Link to="/wishlist"><FaHeart style={styles.icon} /></Link>
          <Link to="/cart"><FaShoppingCart style={styles.icon} /></Link>

          {isMobile && (
            <FaBars
              onClick={() => setMenuOpen(!menuOpen)}
              style={{ ...styles.icon, marginLeft: "10px" }}
            />
          )}
        </div>
      </nav>

      {/* Padding spacer to avoid content under navbar */}
      <div style={{ height: "110px" }} />
    </>
  );
}

const styles = {
  navbar: {
    position: "fixed",
    top: 0,
    width: "100%",
    zIndex: 1000,
    padding: "12px 24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    color: "#fff",
    backgroundColor: "rgb(0, 17, 255)", 
  },
  logo: { fontSize: "28px", fontWeight: "800", textDecoration: "none", color: "#fff", marginRight: "20px" },
  left: { flex: 2, display: "flex", alignItems: "center", gap: "20px" },
  center: { flex: 2, display: "flex", justifyContent: "center" },
  right: { flex: 2, display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "12px" },
  link: { color: "#fff", textDecoration: "none", fontWeight: "500" },
  dropdown: { position: "relative" },
  dropdownToggle: { cursor: "pointer", color: "#fff", fontWeight: "500" },
  categoryMenu: {
    position: "absolute", top: "30px", left: 0, backgroundColor: "#fff",
    padding: "12px", borderRadius: "8px", boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
    display: "flex", flexDirection: "column", gap: "10px", zIndex: 10
  },
  activeCategory: { position: "relative", fontWeight: "bold", cursor: "pointer", paddingRight: "20px" },
  subMenu: {
    position: "absolute", top: 0, left: "100%", backgroundColor: "#f9f9f9",
    padding: "10px", borderRadius: "6px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    display: "flex", flexDirection: "column", gap: "8px"
  },
  subItem: { cursor: "pointer", color: "#2d3436" },
  inactiveCategory: { color: "#aaa", fontStyle: "italic" },
  dropdownBox: {
    position: "absolute", top: "30px", right: 0, background: "#fff",
    padding: "10px", borderRadius: "6px", boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    display: "flex", flexDirection: "column", gap: "10px"
  },
  dropdownItem: { textDecoration: "none", color: "#2d3436", fontWeight: "500" },
  dropdownBtn: { background: "transparent", border: "none", color: "#d63031", cursor: "pointer", fontWeight: 600 },
  searchGroup: { display: "flex" },
  searchInput: {
    padding: "8px 14px", border: "1px solid #ccc", borderRadius: "20px 0 0 20px",
    width: "250px"
  },
  searchBtn: {
    padding: "8px 14px", border: "1px solid #ccc", backgroundColor: "#0984e3",
    color: "#fff", borderRadius: "0 20px 20px 0", cursor: "pointer"
  },
  icon: { fontSize: "20px", cursor: "pointer", color: "#fff" },
  phoneCTA: {
    backgroundColor: "#2ecc71", color: "#fff", padding: "10px 16px",
    borderRadius: "20px", textDecoration: "none", fontWeight: "600",
    display: "flex", alignItems: "center", gap: "8px", fontSize: "14px",
    transition: "all 0.3s ease", boxShadow: "0 0 0 transparent",
    animation: "pulseIcon 1.2s infinite"
  },
  ringingIcon: {
    animation: "ring 1s infinite ease-in-out",
    display: "inline-block"
  }
};

export default NavBar;
